import React from 'react';
import './PurchaseOrderEditor.css';
import Button from 'components/shared/button/Button';
import PropTypes from 'prop-types';
import DocumentLink from 'components/shared/document/DocumentLink';
import Dropzone from 'react-dropzone';
import uploadSvg from 'images/upload.svg';
import Input from 'components/shared/input/Input';
import FilesUploadedViewer from 'components/shared/files/FilesUploadedViewer';
import removeSvg from 'images/remove.svg';

export default function PurchaseOrderEditor(props) {
  const handleCancel = () => {
    if (props.onCancel) {
      props.onCancel();
    }
  };

  const handleDocumentDrop = (files) => {
    if (props.onDocumentDrop && files.length > 0) {
      props.onDocumentDrop(files[0]);
    }
  };

  const handleDocumentRemove = () => {
    if (props.onDocumentRemove) {
      props.onDocumentRemove();
    }
  };

  const handleEdit = () => {
    if (props.onEdit) {
      props.onEdit();
    }
  };

  const handleNumberChange = (value) => {
    if (props.onNumberChange) {
      props.onNumberChange(value);
    }
  };

  const handleSave = () => {
    if (props.onSave) {
      props.onSave();
    }
  };

  const renderButton = (props) => {
    if (props.edit) {
      const saveDisabled =
        (props.documentUrl === null && props.documentFile === null) ||
        props.number === '';
      return (
        <div className="buttons-container">
          <Button
            className="button-orange"
            disabled={saveDisabled}
            label="Save"
            onClick={handleSave}
          />
          <Button
            className="button-white"
            label="Cancel"
            onClick={handleCancel}
          />
        </div>
      );
    } else {
      return (
        <Button
          id="edit-button"
          className="button-orange"
          label="Edit"
          onClick={handleEdit}
        />
      );
    }
  };

  const renderDocument = (props) => {
    if (props.edit) {
      if (props.documentUrl !== null) {
        return (
          <FilesUploadedViewer
            documents={[{ id: 1, document: { url: props.documentUrl } }]}
            showLink={true}
            onDocumentRemove={handleDocumentRemove}
          />
        );
      } else if (props.documentFile !== null) {
        return (
          <div className="file-viewer">
            <DocumentLink
              file={props.documentFile}
              showIcon={false}
              showLink={true}
            />
            <img src={removeSvg} alt="remove" onClick={handleDocumentRemove} />
          </div>
        );
      } else {
        return (
          <Dropzone
            accept="application/pdf, .doc, .docx, .xls, .xlsx"
            className="dropzone-container"
            multiple={false}
            onDrop={handleDocumentDrop}
          >
            <span>Please drag and drop any file into this area</span>
            <img src={uploadSvg} alt="upload" />
          </Dropzone>
        );
      }
    } else if (props.documentUrl !== null) {
      return (
        <DocumentLink
          showIcon={false}
          showLink={true}
          url={props.documentUrl}
        />
      );
    } else if (props.documentFile !== null) {
      return (
        <DocumentLink
          file={props.documentFile}
          showIcon={false}
          showLink={true}
        />
      );
    }
  };

  const renderNumber = (props) => {
    if (props.edit) {
      return <Input value={props.number} onChange={handleNumberChange} />;
    } else {
      return props.number;
    }
  };

  return (
    <div className="purchase-order-editor">
      <table>
        <colgroup>
          <col />
          <col />
        </colgroup>
        <tbody>
          <tr>
            <td>Document</td>
            <td>{renderDocument(props)}</td>
          </tr>
          <tr>
            <td>Number</td>
            <td>{renderNumber(props)}</td>
          </tr>
          {!props.readOnly && (
            <tr className="button-row">
              <td colSpan={2}>{renderButton(props)}</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}

PurchaseOrderEditor.propTypes = {
  documentFile: PropTypes.object,
  documentUrl: PropTypes.string, // url
  edit: PropTypes.bool,
  number: PropTypes.string,
  readOnly: PropTypes.bool,
  onCancel: PropTypes.func,
  onDocumentDrop: PropTypes.func,
  onDocumentRemove: PropTypes.func,
  onEdit: PropTypes.func,
  onNumberChange: PropTypes.func,
  onSave: PropTypes.func,
};

PurchaseOrderEditor.defaultProps = {
  documentFile: null,
  documentUrl: null,
  edit: false,
  number: '',
  readOnly: false,
};



// WEBPACK FOOTER //
// ./src/components/admin/work-orders/details/purchase-order/PurchaseOrderEditor.js